import secondsToHms from './secondsToHms';

export type DurationPart = { unit: 'hours' | 'minutes' | 'seconds'; count: number };

/**
 * The non-zero hours, minutes and seconds in a duration, largest first, for a humanised label:
 * 1,440s is just `[{ unit: 'minutes', count: 24 }]`, not "0 hours, 24 minutes, 0 seconds".
 * Zero (or no value) is `[{ unit: 'seconds', count: 0 }]`, so there's always something to show.
 * Translate each part with `Reporting.durationUnits.<unit>` (pluralised on `count`).
 */
const durationParts = (seconds: number | null | undefined): DurationPart[] => {
    const { h, m, s } = secondsToHms(Math.max(0, Math.round(seconds ?? 0)));
    const parts: DurationPart[] = [
        { unit: 'hours' as const, count: h },
        { unit: 'minutes' as const, count: m },
        { unit: 'seconds' as const, count: s },
    ].filter(part => part.count > 0);

    return parts.length > 0 ? parts : [{ unit: 'seconds', count: 0 }];
};

export default durationParts;
